"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

var _affiliateActions = require("../actions/affiliate-actions");

var _wsActions = require("../actions/ws-actions");

var socketUrl = function socketUrl() {
  return "".concat((0, _wsActions.baseUrl)(), "/affiliate/ws/external/user-event");
};

var socketPredicate = function socketPredicate(action) {
  return action.type === _affiliateActions.SOCKET_CONNECT;
};

var shouldSend = function shouldSend(action) {
  return action.type === _affiliateActions.SAVE_SOCKET_USER_EVENT;
};

var createUserEventSocketMiddleware = function createUserEventSocketMiddleware() {
  var sendInterval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 5000;
  var reconnect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (0, _.createSocketMiddleware)(socketUrl(), 'PING', socketPredicate, shouldSend, null, {
    sendInterval: sendInterval,
    reconnect: reconnect
  });
};

var _default = createUserEventSocketMiddleware;
exports.default = _default;